import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import { DigitalSignatureModal } from 'portal-modules/documents/components/modals'
import { ModalControl } from '@entrata/portals-common/lib/components'
import { useModalControl } from '@entrata/portals-common/lib/hooks'
import { connect } from 'react-redux'

import { cx } from 'emotion'

const SignButton = ({ appearance, className, isActive, label, ...rest }) => (
  <Button
    {...rest}
    appearance={appearance}
    className={cx(className, { active: isActive })}
    disabled={!isActive}
  >
    {label}
  </Button>
)

SignButton.propTypes = {
  appearance: PropTypes.string,
  className: PropTypes.string,
  isActive: PropTypes.bool,
  label: PropTypes.string,
}

const SignService = ({
  appearance,
  isActive,
  className,
  label,
  onDigitalSignModalOpen,
  onSign,
  requireFullName,
  first_name,
  last_name,
  middle_name,
  maternal_last_name,
  require_digital_sign,
  noticeForms,
}) => {
  const control = useModalControl()
  typeof onDigitalSignModalOpen === 'function' &&
    onDigitalSignModalOpen(control.onClick)

  const getResidetFullNameOrInitials = () => {
    return requireFullName
      ? `${first_name && first_name} ${last_name && last_name}`
      : `${first_name[0]}${middle_name && middle_name[0]}${
          last_name[0]
        }${maternal_last_name && maternal_last_name[0]}`
  }

  return (
    <ModalControl>
      {({ onClick, ref, ...props }) => (
        <Fragment>
          <SignButton
            appearance={appearance}
            ref={ref}
            isActive={isActive}
            label={label}
            onClick={require_digital_sign  ? onClick : () => onSign({ 'full_name': '' })}
            className={className}
          />
          {require_digital_sign && (
          <DigitalSignatureModal
            {...props}
            label={requireFullName ? __('Your Full Name') : __('Your Initials')}
            name='full_name'
            noticeForms={noticeForms}
            onSubmit={value => onSign(value)}
            title={
              requireFullName
                ? __('Type your name [{%s, 0}] to record digital signature.', [
                    getResidetFullNameOrInitials(),
                  ])
                : __(
                    'Type your initials [{%s, 0}] to record digital signature.',
                    [getResidetFullNameOrInitials()],
                  )
            }
          />
          )}
        </Fragment>
      )}
    </ModalControl>
  )
}

SignService.propTypes = {
  appearance: PropTypes.string,
  isActive: PropTypes.bool,
  label: PropTypes.string,
  onDigitalSignModalOpen: PropTypes.func.isRequired,
  onSign: PropTypes.func.isRequired,
  requireFullName: PropTypes.bool,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  middle_name: PropTypes.string,
  maternal_last_name: PropTypes.string,
  require_digital_sign: PropTypes.bool,
  noticeForms: PropTypes.object,
}

SignService.defaultProps = {
  appearance: 'action',
  isActive: true,
  label: __('Sign'),
  require_digital_sign: true
}

export default connect(
  ({
    profile: { first_name, last_name, middle_name, maternal_last_name },
  }) => ({
    first_name,
    last_name,
    middle_name,
    maternal_last_name,
  }),
)(SignService)
